// removed by extract-text-webpack-plugin
module.exports = {"receipt-total-box":"app-components-receipt-invoices-Total-__Total___1LIsm","receipt-counting-box":"app-components-receipt-invoices-Total-__Total___1mn2t","receipt-total":"app-components-receipt-invoices-Total-__Total___2Igej","total-invoice":"app-components-receipt-invoices-Total-__Total___16BvX","amount-received":"app-components-receipt-invoices-Total-__Total___1Gdi0","amount-due":"app-components-receipt-invoices-Total-__Total___oiaSS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/Total/Total.css
// module id = 816
// module chunks = 0